// layoutPageViewConfig.js

function normalizeString(value) {
	return String(value || '').trim();
}

export const PORTAL_VIEW_TYPE_METADATA = Object.freeze({
	CALENDAR: {
		noun: 'calendar',
		title: 'Add a calendar',
	},
	GALLERY: {
		noun: 'gallery',
		title: 'Add a gallery',
	},
	LIST: {
		noun: 'list',
		title: 'Add a list',
	},
	TABLE: {
		noun: 'table',
		title: 'Add a table',
	},
	TIMELINE: {
		noun: 'timeline',
		title: 'Add a timeline',
	},
});

/**
 * getPageViewTypeMetadata
 *
 * Resolves the page authoring copy for a given page-safe view type.
 *
 * @param {string} viewType - Requested page view type.
 * @returns {object} The matching page view metadata.
 */
export function getPageViewTypeMetadata(viewType) {
	const normalizedViewType = normalizeString(viewType).toUpperCase();
	if (!normalizedViewType) {
		return {
			noun: 'view',
			title: 'Add a view',
		};
	}

	return PORTAL_VIEW_TYPE_METADATA[normalizedViewType] || PORTAL_VIEW_TYPE_METADATA.LIST;
}

/**
 * buildPageViewToolbarActions
 *
 * Builds the page-safe view actions shown in the layout editor toolbar.
 *
 * @param {function} onOpenPageViewTypeModal - Opens the page type picker for a slot and view type.
 * @param {string} slotKey - Target slot key.
 * @returns {array} The toolbar actions for page-safe views.
 */
export function buildPageViewToolbarActions(onOpenPageViewTypeModal, slotKey) {
	if (typeof onOpenPageViewTypeModal !== 'function') return [];

	return [
		{
			iconKey: 'format_list_bulleted',
			label: 'Add a list',
			onClick: () => onOpenPageViewTypeModal(slotKey, 'LIST'),
			title: 'Add a list of related items',
		},
		{
			iconKey: 'gallery_thumbnail',
			label: 'Add a gallery',
			onClick: () => onOpenPageViewTypeModal(slotKey, 'GALLERY'),
			title: 'Add a gallery of related items',
		},
		{
			iconKey: 'table',
			label: 'Add a table',
			onClick: () => onOpenPageViewTypeModal(slotKey, 'TABLE'),
			title: 'Add a table of related items',
		},
		{
			iconKey: 'view_timeline',
			label: 'Add a timeline',
			onClick: () => onOpenPageViewTypeModal(slotKey, 'TIMELINE'),
			title: 'Add a timeline of related items',
		},
		{
			iconKey: 'calendar_month',
			label: 'Add a calendar',
			onClick: () => onOpenPageViewTypeModal(slotKey, 'CALENDAR'),
			title: 'Add a calendar of related items',
		},
	];
}